import apiClient from './client'
import type { User, LoginCredentials, AuthTokens } from '@/types'

export async function login(credentials: LoginCredentials): Promise<AuthTokens> {
  const formData = new URLSearchParams()
  formData.append('username', credentials.email)
  formData.append('password', credentials.password)

  const response = await apiClient.post<AuthTokens>('/auth/login', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })

  return response.data
}

export async function logout(): Promise<void> {
  const refreshToken = localStorage.getItem('refresh_token')
  try {
    // Send the refresh token so the server can revoke it (it stays valid in
    // Redis for 30 days otherwise).
    await apiClient.post('/auth/logout', refreshToken ? { refresh_token: refreshToken } : {})
  } finally {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
  }
}

export async function getCurrentUser(): Promise<User> {
  const response = await apiClient.get<User>('/auth/me')
  return response.data
}

export async function changePassword(currentPassword: string, newPassword: string): Promise<void> {
  await apiClient.put('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword,
  })
}

export async function refreshToken(refresh_token: string): Promise<AuthTokens> {
  const response = await apiClient.post<AuthTokens>('/auth/refresh', {
    refresh_token,
  })
  return response.data
}
